import React, { useState } from "react";
import "./Faq.css";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return (
    <div>
      <section id="faq">
        <div className="container ">
          <div className="row align-items-center">
            <div className="centered-container">
              <h2
                className="section-heading"
                data-aos="zoom-in-down"
                data-aos-delay="100"
                data-aos-duration="900"
              >
                Frequently Asked Questions
              </h2>
              <p
                className="section-para text-border"
                data-aos="zoom-in-up"
                data-aos-delay="150"
                data-aos-duration="900"
              >
                Overview of our services, mission, and general inquiries.
              </p>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="faq-image col-12 col-md-5 col-lg-6">
              <img src="assets/Images/weddingg.png" alt="faqimage" />
            </div>
            <div className="col-12 col-md-5 col-lg-6">
              <div className="faq-container">
                <div className="accordion__wrapper">
                  <h1 className="accordion__title">
                    Frequently Asked Questions
                  </h1>
                  {faqData.map((item, index) => (
                    <div key={index} className="accordion">
                      <div
                        className="accordion__header"
                        onClick={() => handleToggle(index)}
                      >
                        <h2 className="accordion__question">{item.question}</h2>
                        <span className="accordion__icon">
                          <i
                            className={`ri-${activeIndex === index ? "subtract" : "add"
                              }-line`}
                          />
                        </span>
                      </div>
                      <div
                        className={`accordion__content ${activeIndex === index ? "active" : ""
                          }`}
                      >
                        <p
                          className="accordion__answer"
                          dangerouslySetInnerHTML={{ __html: item.answer }}
                        ></p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

  const faqData = [
    {
      question: "How do we choose the perfect destination?",
      answer: `
        <ul>
          <li>Research popular destinations, considering factors like budget, guest count, and personal preferences.</li>
          <li>Shortlist 2-3 options and consult with a travel agent or wedding planner.</li>
        </ul>`,
    },
    {
      question: "How do we plan a destination wedding from afar?",
      answer: `
        <ul>
          <li>Hire a local wedding planner or coordinator.</li>
          <li>Utilize video conferencing for meetings and venue tours.</li>
          <li>Create a detailed timeline and checklist.</li>
        </ul>`,
    },
    {
      question: "What do we expect from the event coordinator?",
      answer: `
        <ul>
          <li><strong>Expertise and Local Knowledge:</strong> Familiarity with local vendors, venues, and legal requirements. Experience in destination weddings to ensure seamless planning.</li>
          <li><strong>Personalization:</strong> Crafting a unique and personalized wedding experience.</li>
          <li><strong>Budget Management:</strong> Providing clear guidance on budgeting, cost-saving tips, and transparent vendor pricing.</li>
          <li><strong>Communication:</strong> Regular updates and prompt responses throughout the planning process.</li>
          <li><strong>Coordination of Logistics:</strong> Managing travel, accommodations, rehearsal dinners, and guest transportation.</li>
          <li><strong>Vendor Recommendations:</strong> Offering a list of trusted local vendors, such as caterers, photographers, and florists.</li>
          <li><strong>Timeline Development:</strong> Creating a detailed timeline with key milestones for the wedding day.</li>
          <li><strong>On-site Coordination:</strong> Overseeing the event, coordinating vendors, and ensuring everything runs smoothly.</li>
        </ul>`,
    },
    {
      question: "What are the costs associated with a destination wedding?",
      answer: `
        <ul>
          <li>Establish a budget and prioritize expenses.</li>
          <li>Research and compare vendor prices.</li>
          <li>Consider an all-inclusive resort or venue.</li>
          <li><a href="#">Click here for detailed budget planning tips</a>.</li>
        </ul>`,
    },
    {
      question: "What's the best way to handle vendor selection?",
      answer: `
        <ul>
          <li>Research local vendors and read reviews.</li>
          <li>Conduct video interviews or meetings.</li>
          <li>Establish clear communication channels and contracts.</li>
        </ul>`,
    },
    {
      question: "What are the essentials to include in our destination wedding contract?",
      answer: `
        <ul>
          <li>Clearly outline vendor responsibilities and expectations.</li>
          <li>Include details on payment terms, cancellations, and refunds.</li>
          <li>Establish a communication plan and timeline.</li>
        </ul>`,
    },
  ];
  // Add more FAQ items here


export default Faq;
